<template>
  <v-app style="background: #E3F2FD; background: linear-gradient(to bottom, #1976D2, #1E88E5, #E3F2FD);">
    <!-- <v-content> -->
    <v-layout row wrap align-center justify-center>
      <v-flex xs6 md6 lg4 class="ma-5">
        <!-- <v-layout row wrap align-center justify-center>
                  <v-row justify="center">
                    <v-img :src="require('@/assets/img/logo_onebox-horizontal-png.png')" max-width="400" max-height="200" />
                  </v-row>
                </v-layout> -->
        <v-card class="mx-auto" outlined id="borderradius">
          <v-card-text class="pa-0">
            <v-layout row wrap align-center justify-center class="ma-0" v-if="this.dataAccountActive.type === 'Business'">
              <v-flex class="pa-4" v-if="status === 'Success'">
                <v-list two-line dense>
                  <v-list-item class="pl-0 pb-0">
                    <v-list-item-content>
             
                      <v-icon color="green" size="150px">mdi-checkbox-marked-circle</v-icon>
                      <h1 class="text-center">ชำระเงินเรียบร้อยแล้ว</h1>
                      <br />
                      <p class="text-center pa-2">"แพ็กเกจหลัก" ทางระบบจะปรับพื้นที่ให้ในรอบบิลถัดไป</p>
                      <p class="text-center">และ "แพ็กเกจเสริม" ทางระบบจะปรับพื้นที่ให้โดยมีผลทันที</p>
                      <v-divider></v-divider>
                      <v-layout>
                        <v-flex lg12 xs12 class="pt-4">
                          <h4 class="text-center pa-1">หมายเลขคำสั่งซื้อ : {{ orderId }}</h4>
                          <h4 class="text-center pa-1">วันที่สั่งซื้อ : {{ formatdatetime(paid_dtm) }}</h4>
                           <h4 class="text-center pa-1">ระบบดำเนินการตรวจสอบการชำระเงิน กรุณารอสักครู่</h4>
                          <!-- <h4 class="text-center pa-1">วันที่รอบบิลถัดไป : {{ formatdatetime(paid_nextmonth) }}</h4> -->
                        </v-flex>
                      </v-layout>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

                <br />
              </v-flex>
              <v-flex class="pa-4" v-else>
                <v-list two-line dense>
                  <v-list-item class="pl-0 pb-0">
                    <v-list-item-content>
             
                      <v-icon color="red" size="150px">mdi-alert</v-icon>
                      <h1 class="text-center">ไม่สำเร็จ</h1>
                      <br />
                      <p class="text-center pa-2">การชำระเงินไม่สำเร็จ กรุณาสอบตรวจสอบอีกครั้ง</p>
                      <v-divider></v-divider>
                      <v-layout>
                        <v-flex lg12 xs12 class="pt-4">
                          <h4 class="text-center pa-1">หมายเลขคำสั่งซื้อ : {{ orderId }}</h4>
                          <h4 class="text-center pa-1">วันที่สั่งซื้อ : {{ formatdatetime(paid_dtm) }}</h4>
                        </v-flex>
                      </v-layout>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

                <br />
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center justify-center class="ma-0" v-else>
               <v-flex class="pa-4" v-if="status === 'Success'">
                <v-list two-line dense>
                  <v-list-item class="pl-0 pb-0">
                    <v-list-item-content>
                      <v-icon color="green" size="150px">mdi-checkbox-marked-circle</v-icon>
                      <h1 class="text-center">ชำระเงินเรียบร้อยแล้ว</h1>
                      <br />
                      <p class="text-center pa-2">ทางระบบดำเนินการปรับพื้นที่เรียบร้อยแล้ว</p>
                      <v-divider></v-divider>
                      <v-layout>
                        <v-flex lg12 xs12 class="pt-4">
                          <h4 class="text-center pa-1">หมายเลขคำสั่งซื้อ : {{ orderId }}</h4>
                          <h4 class="text-center pa-1">วันที่สั่งซื้อ : {{ formatdatetime(paid_dtm) }}</h4>
                          <h4 class="text-center pa-1">ระบบดำเนินการตรวจสอบการชำระเงิน กรุณารอสักครู่</h4>
                          <!-- <h4 class="text-center pa-1">วันที่รอบบิลถัดไป : {{ formatdatetime(paid_nextmonth) }}</h4> -->
                        </v-flex>
                      </v-layout>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <br />
              </v-flex>
              <v-flex class="pa-4" v-else>
                <v-list two-line dense>
                  <v-list-item class="pl-0 pb-0">
                    <v-list-item-content>
                      <v-icon color="red" size="150px">mdi-alert</v-icon>
                      <h1 class="text-center">ไม่สำเร็จ</h1>
                      <br />
                      <p class="text-center pa-2">การชำระเงินไม่สำเร็จ กรุณาสอบตรวจสอบอีกครั้ง</p>
                      <v-divider></v-divider>
                      <v-layout>
                        <v-flex lg12 xs12 class="pt-4">
                          <h4 class="text-center pa-1">หมายเลขคำสั่งซื้อ : {{ orderId }}</h4>
                          <h4 class="text-center pa-1">วันที่สั่งซื้อ : {{ formatdatetime(paid_dtm) }}</h4>
                        </v-flex>
                      </v-layout>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <br />
              </v-flex>
            </v-layout>
             <v-layout row wrap justify-center>
          <v-flex lg12 xs12 class="ma-6 mr-4 ml-4 ">
            <div class="text-center">
              <v-btn class="ma-2" color="primary" dark @click="goback()">
                กลับสู่หน้าหลัก
              </v-btn>
              <v-btn class="ma-2" color="primary" outlined dark v-if="status === 'Success'&& fileid !== ''" @click="fn_download_taxinvoice()">
                ใบกำกับภาษี
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- </v-content> -->
    <dialogsnackbardowload
      :show="opensnackbardownloadfile"
      @closedialog="opensnackbardownloadfile = false"
      :filedata="file"
      :percen="newpercen"
      :name="namefile"
      :list="new_list"
      :btsdownload="btsdownload"
    ></dialogsnackbardowload>
  </v-app>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import VueCookies from "vue-cookies";
import { required, maxLength, email } from "vuelidate/lib/validators";
import Swal from "sweetalert2/dist/sweetalert2.js";
import gbfGenerate from "@/globalFunctions/generateAuthorize";
import gbfdecodearraybuffer from "@/globalFunctions/decodearraybuffer";
const dialogsnackbardowload = () => import("../components/optional/dialog-snackbardownload");

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  data: function() {
    return {
      orderIdRef:"",
      fileid:"",
      orderId: "",
      paid_dtm: "",
      status: "",
      newlist: [],
      namefile: "",
      paid_nextmonth: "",
      file: {},
      percentCompleted: 0,
      newpercen: 0,
      new_list: [],
      btsdownload: false,
      listdatadowload: [],
      opensnackbardownloadfile: false,
    };
  },
  components: {
    dialogsnackbardowload,
  },
  computed: {
    ...mapState(["username", "authorize", "account_active","color"]),
    ...mapState({ processloader: "loading" }),
    ...mapGetters([
      "dataUsername",
      "dataAuthorize",
      "dataAccountActive",
      "dataAccesstoken",
      "dataBusinessProfile",
      "dataCitizenProfile",
      "dataDepartmentAccessId",
      "dataAccountId",
       "dataStorageUsage",
      "dataStorageMax",
    ]),
  },
  methods: {
 
  },
  mounted() {1
    console.log(this.$route.query);
    this.orderId = this.$route.query.orderId;
    this.paid_dtm = this.$route.query.paid_dtm;
    this.status = this.$route.query.status_payment;
    this.fileid = this.$route.query.file_id
    this.orderIdRef = this.$route.query.orderIdRef
    this.paid_nextmonth = this.$route.query.paid_nextmonth
  },
};
</script>
<style>
#borderradius {
  border-radius: 20px;
}
</style>
